module.exports = __webpack_public_path__ + "static/Logo-M-12a28aa511deefa3d0cddde4d9343e47.png";